module.exports = __webpack_public_path__ + "img/spooKeyBadge2021.daee6778.png";